export default "__VITE_ASSET__9d25bab7__"